import css from '@styled-system/css'
import * as React from 'react'
import styled, { StyledComponent, ThemeContext } from 'styled-components'
import {
  color,
  ColorProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system'

const SvgIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    size?: number | string
    color?: string
  },
) => {
  const { size } = props

  if (size != null) {
    props = {
      width: size,
      height: size,
      ...props,
    }
  }

  const themeContext = React.useContext(ThemeContext)

  if (props.color != null) {
    props = { ...props, color: themeContext.colors[props.color] || props.color }
  }

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#fullscreen_svg__clip0)" fill={props.color || '#000'}>
        <path d="M8.813 5.166h22.943a2.58 2.58 0 002.583-2.583A2.58 2.58 0 0031.756 0H2.34c-.03 0-.06 0-.091.03-.061 0-.091 0-.152.03-.03 0-.091.031-.122.031-.06 0-.09 0-.152.03-.03 0-.09.03-.121.03-.03 0-.091.031-.122.031-.03.03-.06.061-.091.061-.03.03-.091.03-.122.06-.03.031-.06.031-.09.062-.061.03-.092.06-.122.06-.03.03-.091.061-.122.092-.03.03-.06.03-.09.06L.576.942c-.03.03-.03.06-.06.091-.03.03-.061.091-.092.122 0 .03-.03.06-.06.09-.03.062-.03.092-.061.122-.03.03-.03.061-.06.122 0 .03-.031.06-.062.122 0 .03 0 .06-.03.09 0 .031-.03.092-.03.122s-.03.091-.03.122c0 .03-.031.091-.031.121s0 .092-.03.122c0 .03 0 .091-.031.122V31.726a2.58 2.58 0 002.583 2.583 2.58 2.58 0 002.583-2.583V8.813l24.615 24.615c.517.516 1.155.76 1.823.76.669 0 1.337-.244 1.824-.76a2.586 2.586 0 000-3.647L8.813 5.166zM5.166 77.187V54.244a2.58 2.58 0 00-2.583-2.583A2.58 2.58 0 000 54.244V83.66c0 .03 0 .06.03.091 0 .06 0 .091.03.152 0 .03.031.091.031.122 0 .03.03.09.03.121 0 .03.03.091.03.122 0 .03.031.09.031.121.03.03.03.061.061.122.03.03.03.091.06.121.031.03.031.061.062.091.03.03.03.061.06.122.03.03.061.06.092.122.03.03.03.06.06.09l.365.365c.03.03.06.03.091.061.03.03.061.061.122.091.03.03.06.03.121.061.03.03.061.03.122.061.03.03.091.03.121.06.03.031.061.031.122.061.03.03.06.03.122.03.03 0 .09.031.121.031.03 0 .091.03.122.03.03 0 .09.031.121.031.03 0 .091 0 .122.03.03 0 .09 0 .121.03H31.787a2.58 2.58 0 002.583-2.582 2.58 2.58 0 00-2.583-2.583H8.813l24.615-24.615c.516-.517.76-1.155.76-1.823 0-.669-.244-1.337-.76-1.824a2.586 2.586 0 00-3.647 0L5.166 77.187zM77.157 80.834H54.213a2.58 2.58 0 00-2.583 2.583A2.58 2.58 0 0054.213 86H83.63c.03 0 .06 0 .09-.03.061 0 .092 0 .153-.03.03 0 .09-.031.121-.031.03 0 .091-.03.122-.03.03 0 .09-.031.121-.031.03 0 .092-.03.122-.03.03-.03.06-.03.121-.061.03-.03.092-.03.122-.06.03-.031.06-.031.091-.062.03-.03.06-.03.122-.06.03-.03.06-.061.121-.092.03-.03.061-.03.091-.06l.365-.365c.03-.03.03-.06.06-.091.031-.03.062-.061.092-.122.03-.03.03-.06.06-.121.031-.03.031-.061.062-.122.03-.03.03-.091.06-.121s.03-.061.061-.122c.03-.03.03-.06.03-.122 0-.03.03-.09.03-.121 0-.03.031-.091.031-.122 0-.03.03-.09.03-.121 0-.03 0-.091.031-.122 0-.03 0-.09.03-.121V54.213a2.58 2.58 0 00-2.583-2.583 2.58 2.58 0 00-2.583 2.583v22.974L56.19 52.572a2.53 2.53 0 00-1.824-.76c-.668 0-1.337.244-1.823.76a2.586 2.586 0 000 3.647l24.615 24.615zM80.834 8.813v22.943a2.58 2.58 0 002.583 2.583A2.58 2.58 0 0086 31.756V2.583 2.34c0-.03 0-.06-.03-.091 0-.061 0-.091-.03-.152 0-.03-.031-.091-.031-.122 0-.03-.03-.09-.03-.121 0-.03-.031-.091-.031-.122 0-.03-.03-.091-.03-.121-.03-.03-.03-.061-.061-.122-.03-.03-.03-.091-.061-.122-.03-.03-.03-.06-.06-.09-.031-.031-.031-.061-.062-.122-.03-.03-.06-.061-.09-.122-.031-.03-.031-.06-.061-.09l-.365-.366c-.03-.03-.061-.03-.091-.06a.418.418 0 00-.122-.092c-.03-.03-.06-.03-.121-.06-.03-.03-.061-.03-.122-.061-.03-.03-.091-.03-.122-.06-.03-.031-.06-.031-.121-.062-.03-.03-.06-.03-.122-.03-.03 0-.09-.03-.121-.03-.03 0-.091-.03-.122-.03-.03 0-.091-.031-.121-.031s-.092 0-.122-.03c-.03 0-.091 0-.122-.031H54.213a2.58 2.58 0 00-2.583 2.583 2.58 2.58 0 002.583 2.583h22.944L52.542 29.781a2.529 2.529 0 00-.76 1.823c0 .669.243 1.337.76 1.824a2.586 2.586 0 003.647 0L80.834 8.813z" />
      </g>
      <defs>
        <clipPath id="fullscreen_svg__clip0">
          <path fill="#fff" d="M0 0h86v86H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

type StyledSystemProps = TypographyProps &
  SpaceProps &
  LayoutProps &
  ColorProps &
  PositionProps

const _style = (
  component: React.FC,
): StyledComponent<
  React.FC<
    React.SVGProps<SVGSVGElement> & {
      size?: number | string
      color?: string
    }
  >,
  Record<string, unknown>,
  StyledSystemProps,
  never
> => {
  const styledSystemProps = [typography, space, layout, color, position]
  return styled(component)(css({}), styledSystemProps)
}

const SvgFullscreen = _style(SvgIcon)

export default SvgFullscreen
